// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3psxo","signatureBlock":"Footer_signatureBlock__34mz_","signature":"Footer_signature__3z0SS"};